import Card from '../ui/Card';

const TONES = {
  neutral: 'bg-gray-100 text-gray-600',
  amber: 'bg-amber-50 text-amber-600',
  green: 'bg-emerald-50 text-emerald-600',
  red: 'bg-rose-50 text-rose-600',
  blue: 'bg-blue-50 text-blue-600',
};

export default function StatCard({ label, value, icon: Icon, tone = 'neutral' }) {
  return (
    <Card className="transition-shadow hover:shadow-md">
      <div className="flex items-center gap-4">
        {Icon && (
          <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${TONES[tone] || TONES.neutral}`}>
            <Icon className="h-5 w-5" />
          </div>
        )}
        <div className="min-w-0">
          <p className="text-sm text-gray-500">{label}</p>
          <p className="mt-0.5 text-2xl font-semibold tracking-tight text-gray-900">{value}</p>
        </div>
      </div>
    </Card>
  );
}
